import { render, staticRenderFns } from "./customVoice.vue?vue&type=template&id=42f02054&scoped=true"
import script from "./customVoice.vue?vue&type=script&lang=js"
export * from "./customVoice.vue?vue&type=script&lang=js"
import style0 from "./customVoice.vue?vue&type=style&index=0&id=42f02054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f02054",
  null
  
)

export default component.exports